import {
  Button,
  Col,
  Create,
  Row,
  SaveButton,
  useForm,
} from "@pankod/refine-antd";
import {
  IResourceComponentsProps,
  useNavigation,
  useNotification,
} from "@pankod/refine-core";
import { PartnerForm } from "components/forms";
import { IPartner } from "interfaces/partner";
import { FC } from "react";
import { normalizePartnerPhone } from "utils/formaters";
import { extractApiErrorMessage } from "utils/utils";

export const PartnerCreate: FC<IResourceComponentsProps> = () => {
  const { goBack } = useNavigation();
  const { open } = useNotification();

  const { formProps, saveButtonProps, queryResult } = useForm<IPartner>({
    errorNotification: false,
    onMutationError: (error) => {
      const message = extractApiErrorMessage(error);
      open?.({
        type: "error",
        description: "Erro ao criar parceiro!",
        message,
      });
    },
  });

  const transformCreatePartnerValues = (values: IPartner): IPartner => ({
    ...values,
    partner_phone: values.partner_phone
      ? normalizePartnerPhone(values.partner_phone)
      : values.partner_phone,
  });

  return (
    <Create
      title="Incluir"
      footerButtons={() => (
        <Row gutter={16}>
          <Col>
            <Button onClick={() => goBack()} style={{ minWidth: "92px" }}>
              Cancelar
            </Button>
          </Col>

          <Col>
            <SaveButton
              {...saveButtonProps}
              icon={null}
              style={{ minWidth: "92px" }}
            >
              Salvar
            </SaveButton>
          </Col>
        </Row>
      )}
    >
      <PartnerForm
        formProps={formProps}
        queryResult={queryResult}
        transformValuesOnSubmit={transformCreatePartnerValues}
      />
    </Create>
  );
};
